export class Application {
  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly notes: string,
    public readonly type: string,
  ) {
  }
}
